import React, { useState } from 'react';

import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import FormulaBuilder from './FormulaBuilder';
import FaultControl from './FaultControl';
import ScoringTab from './ScoringTab';
import RuleTab from './RuleTab';
import BobConfirmButton from '../../../components/BobConfirmButton';
import AssignTab from './AssignTab';
import ParametersTab from './ParametersTab';

import * as classes from './FormulaBuilderTabs.module.css';

const font = '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif';

const FormulaBuilderTabs = ({
    ...props
}) => {
    const [tabIndex, setTabIndex] = useState(0);
    const [formula, setFormula] = useState('');

    const tabStyle = { width: '10rem', minWidth: '5rem', textTransform: 'none', fontFamily: font, fontSize: '1.2rem' };

    const handleChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    const renderListPanel = index => {
        if (index === 0) {
            return <FormulaBuilder setFormula={setFormula} />;
        } else if (index === 1) {
            return <FaultControl />;
        } else if (index === 2) {
            return <AssignTab />;
        } else if (index === 3) {
            return <ParametersTab />;
        } else if (index === 4) {
            return <ScoringTab />;
        } else if (index === 5) {
            return <RuleTab />;
        }
    };

    const renderClass = tabIndex => {
        if (tabIndex === 4) {
            return classes.ButtonContainerBordered;
        } else {
            return classes.ButtonContainer;
        }
    };

    const renderButtons = tabIndex => {
        if (tabIndex === 0 || tabIndex === 1) {
            return (
                <React.Fragment>
                    <BobConfirmButton
                        className={classes.Buttons}
                        label={'Cancel'}
                    />
                    <BobConfirmButton
                        className={classes.Buttons}
                        label={'Apply & Close'}
                    />
                    <BobConfirmButton
                        className={classes.Buttons}
                        label={'Test Calculation'}
                    />
                </React.Fragment>
            );
        } else if (tabIndex === 2) {
            return (
                <React.Fragment>
                    <BobConfirmButton
                        className={classes.Buttons}
                        label={'Cancel'}
                    />
                    <BobConfirmButton
                        className={classes.Buttons}
                        label={'Apply Rule'}
                    />
                </React.Fragment>
            );
        } else if (tabIndex === 3) {
            return (
                <React.Fragment>
                    <BobConfirmButton
                        className={classes.Buttons}
                        label={'Cancel'}
                    />
                    <BobConfirmButton
                        className={classes.Buttons}
                        label={'Save'}
                    />
                </React.Fragment>
            );
        } else if (tabIndex === 4 || tabIndex === 5) {
            return (
                <React.Fragment>
                    <BobConfirmButton
                        className={classes.Buttons}
                        label={'Cancel'}
                    />
                    <BobConfirmButton
                        className={classes.Buttons}
                        label={'Apply Scoring'}
                    />
                </React.Fragment>
            );
        }
    };


    return (
        <Paper className={classes.TabContainer}>
            <Tabs
                TabIndicatorProps={{ style: { background: 'black' } }}
                value={tabIndex}
                onChange={handleChange}
            >
                <Tab value={0} style={tabStyle} label="Template" />
                <Tab value={1} style={tabStyle} label="Fault Control" />
                <Tab value={2} style={tabStyle} label="Assign" />
                <Tab value={3} style={tabStyle} label="Parameters" />
                <Tab value={4} style={tabStyle} label="Scoring" />
                <Tab value={5} style={tabStyle} label="Rule" />
            </Tabs>
            <div>
                {renderListPanel(tabIndex)}
            </div>
            <div className={renderClass(tabIndex)}>
                <span style={{fontSize: '1.4rem'}}>
                    {formula}
                </span>
                <div style={{float: 'right'}}>
                    {renderButtons(tabIndex)}
                </div>
            </div>
        </Paper>
    );
};

export default FormulaBuilderTabs;
